import React, { useEffect, useState } from 'react';
import classes from './allSitesSearchBar.module.css';
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters2.png';
import sort from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sorting.png';
import { serviceActions } from '../../store/service-Slice';
import { useDispatch, useSelector } from 'react-redux';
import DataManager from '../../hooks/DataManager';

// ── helpers ────────────────────────────────────────────────────

const toggle = (arr, val) =>
  arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];

const Section = ({ label, badge, open, onToggle, children }) => (
  <div className={classes.section}>
    <div className={classes.sectionHeader} onClick={onToggle}>
      <div className={classes.sectionHeaderLeft}>
        <span className={classes.sectionLabel}>{label}</span>
        {badge > 0 && <span className={classes.badge}>{badge}</span>}
      </div>
      <span className={`${classes.chevron} ${open ? classes.chevronOpen : ''}`}>▼</span>
    </div>
    {open && <div className={classes.sectionBody}>{children}</div>}
  </div>
);

const Pills = ({ options, selected, onToggle }) => (
  <div className={classes.pills}>
    {options.map(opt => (
      <button
        key={opt}
        type="button"
        className={`${classes.pill} ${selected.includes(opt) ? classes.pillActive : ''}`}
        onClick={() => onToggle(opt)}
      >
        {opt}
      </button>
    ))}
  </div>
);

const CheckRow = ({ label, checked, onChange }) => (
  <label className={classes.checkRow}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    {label}
  </label>
);

// ── Component ──────────────────────────────────────────────────

const AllSitesSearchBar = (props) => {
  const {
    placeholder, 
    onChange, 
    value, 
    handleFocus, 
    handleBlur, 
    showFilterButton,
    groups, 
    includeSubgroups, setIncludeSubgroups,
    online, setOnline, 
    offline, setOffline,
    deviceTag, setDeviceTag,
    cloudController, setCloudController, 
    davantis, setDavantis, 
    G2CC, setG2CC, 
    ESP, setESP, 
    RPi, setRPi,
    groupName, setGroupName,
    submit, setSubmit,
    noTag, setNoTag,
    isControllers,
    noUsers, setNoUsers,
    liveViewStatus, setLiveViewStatus,
    scheduleOnly, setScheduleOnly,
    hasAjax, setHasAjax,
    hasHik, setHasHik,
    hasAIBOX, setHasAIBOX,
    hasDahua, setHasDahua,
    //hasCamect, setHasCamect,
    active, setActive,
    hasPadlock, setHasPadlock, 
    hasKeybox, setHasKeybox, 
    hasGateway, setHasGateway,
    hasSigfox, setHasSigfox, 
    hasIndSigfox, setHasIndSigfox, 
    hasEfento, setHasEfento, 
    hasTeltonika, setHasTeltonika,
    hasSchedule, setHasSchedule, 
    hasTempSchedules, setHasTempSchedules,
    activePinCount, setActivePinCount,
    sortAsc, setSortAsc, 
    sUserCount, setSUserCount, 
    sCreated, setSCreated,
    sFirmware, setSFirmware, 
    sName, setSName, 
    sCameraCount, setSCameraCount,
    isGroupSites,
    isActiveSites,
    isInactiveSites,
    ruleV2Owner, setRuleV2Owner, 
    ruleV2Parent, setRuleV2Parent, 
    ruleV2Affected, setRuleV2Affected,
    connectionIssues, setConnectionIssues,
    hasCamerasLinked, setHasCamerasLinked,
    isInitialLoading, setIsInitialLoading,
    billable, setBillable, 
    billingFrequency, setBillingFrequency, 
    billedTo, setBilledTo, 
    sDateOfSale, setSDateOfSale,
    sLastInvoice, setSLastInvoice,
    sDateMadeActive, setSDateMadeActive
  } = props;

  const dispatch = useDispatch();
  const service = useSelector(state => state.service);
  const companyName = useSelector(state => state.auth.companyName);
  const isEyeSpyFX = companyName === 'EyeSpyFX';

  const [showFilters, setShowFilters] = useState(false);
  const [showSorts, setShowSorts] = useState(false);
  const [openSections, setOpenSections] = useState({});

  // ── local filter state ──────────────────────────────────────
  const [localOnline, setLocalOnline] = useState(online);
  const [localOffline, setLocalOffline] = useState(offline);
  const [localDeviceTag, setLocalDeviceTag] = useState(deviceTag);
  const [localGroupName, setLocalGroupName] = useState(groupName);
  const [localIncludeSubgroups, setLocalIncludesSubgroups] = useState(includeSubgroups);
  const [localNoTag, setLocalNoTag] = useState(noTag);
  const [localActive, setLocalActive] = useState(active);
  const [localNoUsers, setLocalNoUsers] = useState(noUsers);
  const [localLiveViewStatus, setLocalLiveViewStatus] = useState(liveViewStatus);
  const [localScheduleOnly, setLocalScheduleOnly] = useState(scheduleOnly);
  const [localHasAjax, setLocalHasAjax] = useState(hasAjax);
  const [localHasHik, setLocalHasHik] = useState(hasHik);
  const [localHasAIBOX, setLocalHasAIBOX] = useState(hasAIBOX);
  const [localHasDahua, setLocalHasDahua] = useState(hasDahua);
  //const [localHasCamect, setLocalHasCamect] = useState(hasCamect);
  const [localHasPadlock, setLocalHasPadlock] = useState(hasPadlock);
  const [localHasKeybox, setLocalHasKeybox] = useState(hasKeybox);
  const [localHasGateway, setLocalHasGateway] = useState(hasGateway);
  const [localHasSigfox, setLocalHasSigfox] = useState(hasSigfox);
  const [localHasIndSigfox, setLocalHasIndSigfox] = useState(hasIndSigfox);
  const [localHasEfento, setLocalHasEfento] = useState(hasEfento);
  const [localHasTeltonika, setLocalHasTeltonika] = useState(hasTeltonika);
  const [localHasSchedule, setLocalHasSchedule] = useState(hasSchedule);
  const [localHasTempSchedule, setLocalHasTempSchedule] = useState(hasTempSchedules);
  const [localActivePinCount, setLocalActivePinCount] = useState(activePinCount);
  const [localSortAsc, setLocalSortAsc] = useState(sortAsc);
  const [localSUserCount, setLocalSUserCount] = useState(sUserCount);
  const [localSCreated, setLocalSCreated] = useState(sCreated);
  const [localSFirmware, setLocalSFirmware] = useState(sFirmware);
  const [localSName, setLocalSName] = useState(sName);
  const [localSCameraCount, setLocalSCameraCount] = useState(sCameraCount);
  const [localRuleV2Owner, setLocalRuleV2Owner] = useState(ruleV2Owner);
  const [localRuleV2Parent, setLocalRuleV2Parent] = useState(ruleV2Parent);
  const [localRuleV2Affected, setLocalRuleV2Affected] = useState(ruleV2Affected);
  const [localConnectionIssues, setLocalConnectionIssues] = useState(connectionIssues);
  const [localHasCamerasLinked, setLocalHasCamerasLinked] = useState(hasCamerasLinked);

  // Billing filters (EyeSpyFX only)
  const [localBillable, setLocalBillable] = useState(billable ?? -1);
  const [localBilledTo, setLocalBilledTo] = useState(billedTo ?? -1);
  const [localBillingFrequency, setLocalBillingFrequency] = useState(billingFrequency ?? -1);
  const [localSDateOfSale, setLocalSDateOfSale] = useState(sDateOfSale ?? 0);
  const [localSLastInvoice, setLocalSLastInvoice] = useState(sLastInvoice ?? 0);
  const [localSDateMadeActive, setLocalSDateMadeActive] = useState(sDateMadeActive ?? 0);

  // Multi-select pill arrays
  const [siteStatusFilters, setSiteStatusFilters] = useState([]);
  const [activeStatusFilters, setActiveStatusFilters] = useState([]);
  const [siteTypeFilters, setSiteTypeFilters] = useState([]);

  const [hasFilters, setHasFilters] = useState(service.hasFilters);

  // sync from props
  useEffect(() => {
    setLocalOnline(online); setLocalOffline(offline); setLocalDeviceTag(deviceTag);
    setLocalGroupName(groupName); setLocalIncludesSubgroups(includeSubgroups);
    setLocalNoTag(noTag); setLocalNoUsers(noUsers); setLocalLiveViewStatus(liveViewStatus);
    setLocalScheduleOnly(scheduleOnly); setLocalHasAjax(hasAjax); setLocalHasHik(hasHik);
    setLocalHasAIBOX(hasAIBOX); setLocalHasDahua(hasDahua); 
    //setLocalHasCamect(hasCamect); setLocalHasPadlock(hasPadlock);
    setLocalHasKeybox(hasKeybox); setLocalHasGateway(hasGateway); setLocalHasSigfox(hasSigfox);
    setLocalHasIndSigfox(hasIndSigfox); setLocalHasEfento(hasEfento); setLocalHasTeltonika(hasTeltonika);
    setLocalHasSchedule(hasSchedule); setLocalHasTempSchedule(hasTempSchedules);
    setLocalActivePinCount(activePinCount); setLocalActive(active); setLocalSortAsc(sortAsc);
    setLocalSUserCount(sUserCount); setLocalSCreated(sCreated); setLocalSFirmware(sFirmware);
    setLocalSName(sName); setLocalSCameraCount(sCameraCount); setLocalRuleV2Owner(ruleV2Owner);
    setLocalRuleV2Parent(ruleV2Parent); setLocalRuleV2Affected(ruleV2Affected);
    setLocalConnectionIssues(connectionIssues); setLocalHasCamerasLinked(hasCamerasLinked);
    setLocalBillable(billable ?? -1); setLocalBilledTo(billedTo ?? -1); setLocalBillingFrequency(billingFrequency ?? -1);
    setLocalSDateOfSale(sDateOfSale ?? 0); setLocalSLastInvoice(sLastInvoice ?? 0); setLocalSDateMadeActive(sDateMadeActive ?? 0);

    setSiteStatusFilters([...(online ? ['Online'] : []), ...(offline ? ['Offline'] : [])]);
    setActiveStatusFilters(active === 1 ? ['Active'] : active === 0 ? ['Inactive'] : []);
    setSiteTypeFilters([
      ...(cloudController ? ['Cloud CC'] : []), ...(davantis ? ['Davantis'] : []),
      ...(G2CC ? ['Virtual'] : []), ...(ESP ? ['iON'] : []), ...(RPi ? ['RPi'] : [])
    ]);
  }, [
    online, offline, deviceTag, groupName, includeSubgroups, noTag, noUsers, liveViewStatus,
    scheduleOnly, hasAjax, hasHik, hasAIBOX, hasDahua, 
    //hasCamect, 
    hasPadlock, hasKeybox, hasGateway,
    hasSigfox, hasIndSigfox, hasEfento, hasTeltonika, hasSchedule, hasTempSchedules,
    activePinCount, active, sortAsc, sUserCount, sCreated, sFirmware, sName, sCameraCount,
    cloudController, davantis, G2CC, ESP, RPi, ruleV2Owner, ruleV2Parent, ruleV2Affected,
    connectionIssues, hasCamerasLinked, billable, billedTo, billingFrequency, sDateMadeActive, sLastInvoice, sDateOfSale
  ]);

  const filterDefaults = {
    active: -1, online: 0, offline: 0, deviceTag: null, cloudController: 0, davantis: 0,
    g2cc: 0, ESP: 0, RPi: 0, groupName: null, includeSubgroups: 0, noTag: 0, searchTerm: null,
    noUsers: 0, liveViewStatus: -1, scheduleOnly: -1, hasAjax: 0, hasHik: 0, hasAIBOX: 0,
    hasDahua: 0, 
    //hasCamect: 0, 
    hasPadlock: 0, hasKeybox: 0, hasGateway: 0, hasSigfox: 0, hasIndSigfox: 0,
    hasEfento: 0, hasTeltonika: 0, hasSchedules: 0, hasTempSchedules: 0, activePinCount: -1,
    sortAsc: 0, sUserCount: 0, sCreated: 1, sFirmware: 0, sName: 0, sCameraCount: 0,
    ruleV2Owner: 0, ruleV2Parent: 0, ruleV2Affected: 0, connectionIssues: 0, hasCamerasLinked: -1,
    billable: -1, billedTo: -1, billingFrequency: -1, sDateMadeActive: 0, sLastInvoice: 0, sDateOfSale: 0
  };

  const setters = {
    online: setOnline, offline: setOffline, deviceTag: setDeviceTag,
    cloudController: setCloudController, davantis: setDavantis, g2cc: setG2CC,
    ESP: setESP, RPi: setRPi, groupName: setGroupName, includeSubgroups: setIncludeSubgroups,
    noTag: setNoTag, noUsers: setNoUsers, liveViewStatus: setLiveViewStatus,
    scheduleOnly: setScheduleOnly, hasAjax: setHasAjax, hasHik: setHasHik,
    hasAIBOX: setHasAIBOX, hasDahua: setHasDahua, 
    //hasCamect: setHasCamect, 
    hasPadlock: setHasPadlock,
    hasKeybox: setHasKeybox, hasGateway: setHasGateway, hasSigfox: setHasSigfox,
    hasIndSigfox: setHasIndSigfox, hasEfento: setHasEfento, hasTeltonika: setHasTeltonika,
    hasSchedules: setHasSchedule, hasTempSchedules: setHasTempSchedules,
    activePinCount: setActivePinCount, sortAsc: setSortAsc, sUserCount: setSUserCount,
    sCreated: setSCreated, sFirmware: setSFirmware, sName: setSName, sCameraCount: setSCameraCount,
    active: setActive, ruleV2Owner: setRuleV2Owner, ruleV2Parent: setRuleV2Parent,
    ruleV2Affected: setRuleV2Affected, connectionIssues: setConnectionIssues,
    hasCamerasLinked: setHasCamerasLinked, 
    billable: setBillable, 
    billedTo: setBilledTo, 
    billingFrequency: setBillingFrequency,
    sDateMadeActive: setSDateMadeActive,
    sLastInvoice: setSLastInvoice,
    sDateOfSale: setSDateOfSale
  };

  const toggleSection = (key) =>
    setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));

  const handleClear = () => onChange({ target: { value: '' } });

  const handleShowFilters = () => { setShowFilters(p => !p); setShowSorts(false); };
  const handleShowSorts = () => { setShowSorts(p => !p); setShowFilters(false); };

  const HandleResetFilters = () => {
    setLocalOnline(0); setLocalOffline(0); setLocalDeviceTag(null); setLocalGroupName(null);
    setLocalIncludesSubgroups(0); setLocalNoTag(0); setLocalNoUsers(0);
    setLocalLiveViewStatus(-1); setLocalScheduleOnly(-1); setLocalHasAjax(0); setLocalHasHik(0);
    setLocalHasAIBOX(0); setLocalHasDahua(0); 
    //setLocalHasCamect(0); 
    setLocalActive(-1); setLocalHasPadlock(0);
    setLocalHasKeybox(0); setLocalHasGateway(0); setLocalHasSigfox(0); setLocalHasIndSigfox(0);
    setLocalHasEfento(0); setLocalHasTeltonika(0); setLocalHasSchedule(0); setLocalHasTempSchedule(0);
    setLocalActivePinCount(-1); setLocalRuleV2Owner(0); setLocalRuleV2Parent(0);
    setLocalRuleV2Affected(0); setLocalConnectionIssues(0); setLocalHasCamerasLinked(-1);
    setLocalBillable(-1); setLocalBilledTo(-1); setLocalBillingFrequency(-1);
    setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0);
    setSiteStatusFilters([]); setActiveStatusFilters([]); setSiteTypeFilters([]);
    setSUserCount(0); setSCreated(1); setSFirmware(0); setSName(0); setSCameraCount(0);
    setBillable(-1); setBilledTo(-1); setBillingFrequency(-1); setSDateMadeActive(0); setSLastInvoice(0); setSDateOfSale(0)
    Object.entries(setters).forEach(([key, setter]) => setter(filterDefaults[key]));
    dispatch(serviceActions.resetFilters(filterDefaults));
    dispatch(serviceActions.setHasFilters(false));
    setHasFilters(false);
    setShowFilters(false);
  };

  const HandleApplyFilters = () => {
    const payload = {
      online: siteStatusFilters.includes('Online') ? 1 : 0,
      offline: siteStatusFilters.includes('Offline') ? 1 : 0,
      deviceTag: localDeviceTag,
      cloudController: siteTypeFilters.includes('Cloud CC') ? 1 : 0,
      davantis: siteTypeFilters.includes('Davantis') ? 1 : 0,
      g2cc: siteTypeFilters.includes('Virtual') ? 1 : 0,
      ESP: siteTypeFilters.includes('iON') ? 1 : 0,
      RPi: siteTypeFilters.includes('RPi') ? 1 : 0,
      groupName: localGroupName,
      includeSubgroups: localIncludeSubgroups,
      noTag: localNoTag,
      noUsers: localNoUsers,
      liveViewStatus: localLiveViewStatus,
      scheduleOnly: localScheduleOnly,
      hasAjax: localHasAjax,
      hasHik: localHasHik,
      //hasCamect: localHasCamect,
      hasAIBOX: localHasAIBOX,
      hasDahua: localHasDahua,
      hasPadlock: localHasPadlock,
      hasKeybox: localHasKeybox,
      hasGateway: localHasGateway,
      hasSigfox: localHasSigfox,
      hasIndSigfox: localHasIndSigfox,
      hasEfento: localHasEfento,
      hasTeltonika: localHasTeltonika,
      hasSchedules: localHasSchedule,
      hasTempSchedules: localHasTempSchedule,
      activePinCount: localActivePinCount,
      sortAsc: localSortAsc,
      sUserCount: localSUserCount,
      sCreated: localSCreated,
      sFirmware: localSFirmware,
      sName: localSName,
      sCameraCount: localSCameraCount,
      ruleV2Owner: localRuleV2Owner,
      ruleV2Parent: localRuleV2Parent,
      ruleV2Affected: localRuleV2Affected,
      connectionIssues: localConnectionIssues,
      hasCamerasLinked: localHasCamerasLinked,
      active: activeStatusFilters.includes('Active') ? 1 : activeStatusFilters.includes('Inactive') ? 0 : -1,
      billable: localBillable,
      billedTo: localBilledTo,
      billingFrequency: localBillingFrequency,
      sDateOfSale: localSDateOfSale,
      sLastInvoice: localSLastInvoice,
      sDateMadeActive: localSDateMadeActive,
    };
    Object.entries(payload).forEach(([key, val]) => setters[key]?.(val));
    dispatch(serviceActions.updateFilters(payload));
    dispatch(serviceActions.setHasFilters(true));
    setHasFilters(true);
    setShowFilters(false);
    setShowSorts(false);
  };

  // ── badge counts ────────────────────────────────────────────
  const statusBadge = siteStatusFilters.length + activeStatusFilters.length;
  const devicesBadge = [
    localHasAjax, localHasDahua, localHasHik, localHasAIBOX, 
    //localHasCamect,
    localHasPadlock, localHasKeybox, localHasGateway,
    localHasSigfox, localHasIndSigfox, localHasEfento, localHasTeltonika
  ].filter(v => v !== 0).length + (localConnectionIssues ? 1 : 0);
  const liveViewBadge = (localLiveViewStatus !== -1 ? 1 : 0) + (localHasCamerasLinked !== -1 ? 1 : 0);
  const schedulesBadge = (localHasSchedule !== 0 ? 1 : 0) + (localHasTempSchedule !== 0 ? 1 : 0) + (localScheduleOnly !== -1 ? 1 : 0);
  const rulesBadge = (localRuleV2Owner ? 1 : 0) + (localRuleV2Parent ? 1 : 0) + (localRuleV2Affected ? 1 : 0);
  const usersBadge = localNoUsers !== 0 ? 1 : 0;
  const detailsBadge = (localNoTag ? 1 : 0) + (localActivePinCount !== -1 ? 1 : 0) + (localDeviceTag ? 1 : 0) + siteTypeFilters.length;
  const groupBadge = (localGroupName ? 1 : 0) + (localIncludeSubgroups ? 1 : 0);

  const billingBadge = (localBillable !== -1 ? 1 : 0) + (localBilledTo !== -1 ? 1 : 0) + (localBillingFrequency !== -1 ? 1 : 0);
  const sortBadge = (localSUserCount ? 1 : 0) + (localSCreated ? 1 : 0) + (localSFirmware ? 1 : 0) + (localSName ? 1 : 0) + (localSCameraCount ? 1 : 0) + (localSDateOfSale ? 1 : 0) + (localSLastInvoice ? 1 : 0) + (localSDateMadeActive ? 1 : 0);

  const clearFilter = (key) => {
    const setter = setters[key];
    const defaultVal = filterDefaults[key];
    if (setter !== undefined) setter(defaultVal);
    dispatch(serviceActions.updateFilters({ [key]: defaultVal }));
  };

  const activeChips = [
    online && { key: 'online', label: 'Online' },
    offline && { key: 'offline', label: 'Offline' },
    active === 1 && { key: 'active', label: 'Active' },
    active === 0 && { key: 'active', label: 'Inactive' },
    hasAjax === 1 && { key: 'hasAjax', label: 'AJAX' },
    hasAjax === 2 && { key: 'hasAjax', label: 'Not AJAX' },
    hasHik === 1 && { key: 'hasHik', label: 'Hikvision' },
    hasHik === 2 && { key: 'hasHik', label: 'Not Hikvision' },
    hasAIBOX === 1 && { key: 'hasAIBOX', label: 'Ganz AIBOX' },
    hasAIBOX === 2 && { key: 'hasAIBOX', label: 'Not Ganz AIBOX' },
    hasDahua === 1 && { key: 'hasDahua', label: 'Dahua' },
    hasDahua === 2 && { key: 'hasDahua', label: 'Not Dahua' },
    //hasCamect === 1 && { key: 'hasCamect', label: 'Camect' },
    //hasCamect === 2 && { key: 'hasCamect', label: 'Not Camect' },
    hasPadlock === 1 && { key: 'hasPadlock', label: 'Smart padlock' },
    hasPadlock === 2 && { key: 'hasPadlock', label: 'Not smart padlock' },
    hasKeybox === 1 && { key: 'hasKeybox', label: 'Keybox' },
    hasKeybox === 2 && { key: 'hasKeybox', label: 'Not keybox' },
    hasGateway === 1 && { key: 'hasGateway', label: 'Gateway' },
    hasGateway === 2 && { key: 'hasGateway', label: 'Not gateway' },
    hasSigfox === 1 && { key: 'hasSigfox', label: 'Sigfox lite contact' },
    hasSigfox === 2 && { key: 'hasSigfox', label: 'Not Sigfox lite contact' },
    hasIndSigfox === 1 && { key: 'hasIndSigfox', label: 'Sigfox industrial' },
    hasIndSigfox === 2 && { key: 'hasIndSigfox', label: 'Not Sigfox industrial' },
    hasEfento === 1 && { key: 'hasEfento', label: 'NB-IOT Sensor' },
    hasEfento === 2 && { key: 'hasEfento', label: 'Not NB-IOT Sensor' },
    hasTeltonika === 1 && { key: 'hasTeltonika', label: 'BLE Sensor' },
    hasTeltonika === 2 && { key: 'hasTeltonika', label: 'Not BLE Sensor' },
    connectionIssues && { key: 'connectionIssues', label: 'CCTV connection issues' },
    liveViewStatus === 1 && { key: 'liveViewStatus', label: 'Live view: On' },
    liveViewStatus === 0 && { key: 'liveViewStatus', label: 'Live view: Off' },
    hasCamerasLinked === 1 && { key: 'hasCamerasLinked', label: 'With cameras' },
    hasCamerasLinked === 0 && { key: 'hasCamerasLinked', label: 'Without cameras' },
    hasSchedule === 1 && { key: 'hasSchedules', label: 'Has schedule' },
    hasSchedule === 2 && { key: 'hasSchedules', label: 'No schedule' },
    hasTempSchedules === 1 && { key: 'hasTempSchedules', label: 'Has temp schedule' },
    hasTempSchedules === 2 && { key: 'hasTempSchedules', label: 'No temp schedule' },
    scheduleOnly === 1 && { key: 'scheduleOnly', label: 'Schedule only: On' },
    scheduleOnly === 0 && { key: 'scheduleOnly', label: 'Schedule only: Off' },
    ruleV2Owner && { key: 'ruleV2Owner', label: 'Has a rule' },
    ruleV2Parent && { key: 'ruleV2Parent', label: 'Parent site' },
    ruleV2Affected && { key: 'ruleV2Affected', label: 'Child site' },
    activePinCount === -2 && { key: 'activePinCount', label: 'Any active switches' },
    activePinCount >= 0 && { key: 'activePinCount', label: `${activePinCount} active switch${activePinCount !== 1 ? 'es' : ''}` },
    cloudController && { key: 'cloudController', label: 'Cloud CC' },
    davantis && { key: 'davantis', label: 'Davantis' },
    G2CC && { key: 'g2cc', label: 'Virtual' },
    ESP && { key: 'ESP', label: 'iON' },
    RPi && { key: 'RPi', label: 'RPi' },
    deviceTag && { key: 'deviceTag', label: `Portal name: "${deviceTag}"` },
    noTag && { key: 'noTag', label: 'No portal name' },
    noUsers === 1 && { key: 'noUsers', label: 'No users' },
    noUsers === 2 && { key: 'noUsers', label: 'Has users' },
    noUsers === 3 && { key: 'noUsers', label: 'Has > 10 users' },
    noUsers === 4 && { key: 'noUsers', label: 'Has > 20 users' },
    !isGroupSites && groupName && { key: 'groupName', label: `Group: ${groupName}` },
    !isGroupSites && includeSubgroups && { key: 'includeSubgroups', label: 'Incl. subgroups' },
    ...(isEyeSpyFX ? [
      billable === 1 && { key: 'billable', label: 'Billable' },
      billable === 0 && { key: 'billable', label: 'Not billable' },
      billable === 2 && { key: 'billable', label: 'Demo' },
      billingFrequency === 0 && { key: 'billingFrequency', label: 'Monthly billing' },
      billingFrequency === 1 && { key: 'billingFrequency', label: 'Annual billing' },
      billingFrequency === 2 && { key: 'billingFrequency', label: 'Billing not set' },
      (billedTo !== -1 && billedTo !== undefined) && { key: 'billedTo', label: `Billed to: ${groups?.find(g => g.id === billedTo)?.name ?? billedTo}` },
    ] : []),
  ].filter(Boolean);

  const handleKeyPress = (e) => { if (e.key === 'Enter') e.preventDefault(); };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <div className={classes.searchContainer}>
        <input
          className={classes.searchBar}
          placeholder={placeholder}
          value={value}
          onKeyPress={handleKeyPress}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          spellCheck={false}
        />

        <div className={classes.buttonGroup}>
          {value && (
            <button className={classes.clearButton} onClick={handleClear} type="button">×</button>
          )}
          {showFilterButton && (
            <button className={classes.filterButton} onClick={handleShowFilters} type="button">
              <img style={{ height: 30, width: 30 }} src={filters} />
            </button>
          )}
          {showFilterButton && (
            <button className={classes.filterButton} onClick={handleShowSorts} type="button">
              <img style={{ height: 30, width: 30 }} src={sort} />
            </button>
          )}
        </div>

        {/* ── Filter panel ─────────────────────────────────── */}
        {showFilters && (
          <div className={classes.panel}>
            <div className={classes.panelHeader}>
              <span className={classes.panelTitle}>Filters</span>
              <div className={classes.panelActions}>
                <button className={classes.resetBtn} type="button" onClick={HandleResetFilters}>Reset</button>
                <button className={classes.applyBtn} type="button" onClick={HandleApplyFilters}>Apply</button>
              </div>
            </div>

            <div className={classes.panelBody}>

              {/* Status */}
              <Section label="Status" badge={statusBadge} open={openSections.status} onToggle={() => toggleSection('status')}>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Connectivity</span>
                  <Pills
                    options={['Online', 'Offline']}
                    selected={siteStatusFilters}
                    onToggle={v => setSiteStatusFilters(toggle(siteStatusFilters, v))}
                  />
                </div>
                {!isActiveSites && !isInactiveSites && (
                  <div className={classes.subSection}>
                    <span className={classes.subLabel}>Active status</span>
                    <Pills
                      options={['Active', 'Inactive']}
                      selected={activeStatusFilters}
                      onToggle={v => setActiveStatusFilters(toggle(activeStatusFilters, v))}
                    />
                  </div>
                )}
              </Section>

              {/* Connected devices */}
              <Section label="Connected devices" badge={devicesBadge} open={openSections.devices} onToggle={() => toggleSection('devices')}>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>CCTV integrations</span>
                  {[
                    { label: 'AJAX', value: localHasAjax, set: setLocalHasAjax },
                    { label: 'Dahua', value: localHasDahua, set: setLocalHasDahua },
                    { label: 'Hikvision', value: localHasHik, set: setLocalHasHik },
                    { label: 'Ganz AIBOX', value: localHasAIBOX, set: setLocalHasAIBOX },
                    // { label: 'Camect', value: localHasCamect, set: setLocalHasCamect },
                  ].map(({ label, value, set }) => (
                    <div className={classes.fieldRow} key={label}>
                      <span className={classes.fieldLabel}>{label}</span>
                      <Pills
                        options={['Has', "Doesn't have"]}
                        selected={value === 1 ? ['Has'] : value === 2 ? ["Doesn't have"] : []}
                        onToggle={v => {
                          if (v === 'Has') set(value === 1 ? 0 : 1);
                          else set(value === 2 ? 0 : 2);
                        }}
                      />
                    </div>
                  ))}
                  <CheckRow
                    label="Only show sites with CCTV connection issues"
                    checked={localConnectionIssues === 1}
                    onChange={() => setLocalConnectionIssues(localConnectionIssues === 1 ? 0 : 1)}
                  />
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>BLE devices</span>
                  {[
                    { label: 'Smart padlock', value: localHasPadlock, set: setLocalHasPadlock },
                    { label: 'Keybox', value: localHasKeybox, set: setLocalHasKeybox },
                    { label: 'Gateway', value: localHasGateway, set: setLocalHasGateway },
                  ].map(({ label, value, set }) => (
                    <div className={classes.fieldRow} key={label}>
                      <span className={classes.fieldLabel}>{label}</span>
                      <Pills
                        options={['Has', "Doesn't have"]}
                        selected={value === 1 ? ['Has'] : value === 2 ? ["Doesn't have"] : []}
                        onToggle={v => {
                          if (v === 'Has') set(value === 1 ? 0 : 1);
                          else set(value === 2 ? 0 : 2);
                        }}
                      />
                    </div>
                  ))}
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Sensors</span>
                  {[
                    { label: 'Sigfox lite contact', value: localHasSigfox, set: setLocalHasSigfox },
                    { label: 'Sigfox industrial', value: localHasIndSigfox, set: setLocalHasIndSigfox },
                    { label: 'Standalone NB-IOT Sensor', value: localHasEfento, set: setLocalHasEfento },
                    { label: 'BLE Sensor', value: localHasTeltonika, set: setLocalHasTeltonika },
                  ].map(({ label, value, set }) => (
                    <div className={classes.fieldRow} key={label}>
                      <span className={classes.fieldLabel}>{label}</span>
                      <Pills
                        options={['Has', "Doesn't have"]}
                        selected={value === 1 ? ['Has'] : value === 2 ? ["Doesn't have"] : []}
                        onToggle={v => {
                          if (v === 'Has') set(value === 1 ? 0 : 1);
                          else set(value === 2 ? 0 : 2);
                        }}
                      />
                    </div>
                  ))}
                </div>
              </Section>

              {/* Live view */}
              <Section label="Live view" badge={liveViewBadge} open={openSections.liveview} onToggle={() => toggleSection('liveview')}>
                <Pills
                  options={['Enabled', 'Disabled']}
                  selected={localLiveViewStatus === 1 ? ['Enabled'] : localLiveViewStatus === 0 ? ['Disabled'] : []}
                  onToggle={v => {
                    if (v === 'Enabled') setLocalLiveViewStatus(localLiveViewStatus === 1 ? -1 : 1);
                    else setLocalLiveViewStatus(localLiveViewStatus === 0 ? -1 : 0);
                  }}
                />
                {localLiveViewStatus !== -1 && (
                  <div className={classes.subIndent}>
                    <span className={classes.subLabel}>Camera links</span>
                    <Pills
                      options={['With cameras', 'Without cameras']}
                      selected={localHasCamerasLinked === 1 ? ['With cameras'] : localHasCamerasLinked === 0 ? ['Without cameras'] : []}
                      onToggle={v => {
                        if (v === 'With cameras') setLocalHasCamerasLinked(localHasCamerasLinked === 1 ? -1 : 1);
                        else setLocalHasCamerasLinked(localHasCamerasLinked === 0 ? -1 : 0);
                      }}
                    />
                  </div>
                )}
              </Section>

              {/* Schedules */}
              <Section label="Schedules" badge={schedulesBadge} open={openSections.schedules} onToggle={() => toggleSection('schedules')}>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Permanent schedules</span>
                  <Pills
                    options={['Has', "Doesn't have"]}
                    selected={localHasSchedule === 1 ? ['Has'] : localHasSchedule === 2 ? ["Doesn't have"] : []}
                    onToggle={v => {
                      if (v === 'Has') setLocalHasSchedule(localHasSchedule === 1 ? 0 : 1);
                      else setLocalHasSchedule(localHasSchedule === 2 ? 0 : 2);
                    }}
                  />
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Temporary schedules</span>
                  <Pills
                    options={['Has', "Doesn't have"]}
                    selected={localHasTempSchedule === 1 ? ['Has'] : localHasTempSchedule === 2 ? ["Doesn't have"] : []}
                    onToggle={v => {
                      if (v === 'Has') setLocalHasTempSchedule(localHasTempSchedule === 1 ? 0 : 1);
                      else setLocalHasTempSchedule(localHasTempSchedule === 2 ? 0 : 2);
                    }}
                  />
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Schedule only mode</span>
                  <Pills
                    options={['Enabled', 'Disabled']}
                    selected={localScheduleOnly === 1 ? ['Enabled'] : localScheduleOnly === 0 ? ['Disabled'] : []}
                    onToggle={v => {
                      if (v === 'Enabled') setLocalScheduleOnly(localScheduleOnly === 1 ? -1 : 1);
                      else setLocalScheduleOnly(localScheduleOnly === 0 ? -1 : 0);
                    }}
                  />
                </div>
              </Section>

              {/* Rules */}
              <Section label="Rules" badge={rulesBadge} open={openSections.rules} onToggle={() => toggleSection('rules')}>
                <div className={classes.pills}>
                  {[
                    { label: 'Has a rule', val: localRuleV2Owner, set: () => setLocalRuleV2Owner(localRuleV2Owner ? 0 : 1) },
                    { label: 'Is a parent site', val: localRuleV2Parent, set: () => setLocalRuleV2Parent(localRuleV2Parent ? 0 : 1) },
                    { label: 'Is a child site', val: localRuleV2Affected, set: () => setLocalRuleV2Affected(localRuleV2Affected ? 0 : 1) },
                  ].map(({ label, val, set }) => (
                    <button
                      key={label}
                      type="button"
                      className={`${classes.pill} ${val ? classes.pillActive : ''}`}
                      onClick={set}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </Section>

              {/* Site details */}
              <Section label="Site details" badge={detailsBadge} open={openSections.details} onToggle={() => toggleSection('details')}>
                <div className={classes.fieldRow}>
                  <span className={classes.fieldLabel}>Active switches</span>
                  <select
                    className={classes.nativeSelect}
                    value={localActivePinCount}
                    onChange={e => setLocalActivePinCount(Number(e.target.value))}
                  >
                    <option value={-1}>Any number</option>
                    <option value={-2}>Any active switches</option>
                    {[0,1,2,3,4,5,6,7,8].map(n => (
                      <option key={n} value={n}>{n} active switch{n !== 1 ? 'es' : ''}</option>
                    ))}
                  </select>
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Site type</span>
                  <Pills
                    options={['Davantis', 'Virtual', 'iON']}
                    selected={siteTypeFilters}
                    onToggle={v => setSiteTypeFilters(toggle(siteTypeFilters, v))}
                  />
                </div>
                <div className={classes.fieldRow}>
                  <span className={classes.fieldLabel}>Portal name contains</span>
                  <input
                    className={classes.textInput}
                    placeholder="Enter keyword..."
                    value={localDeviceTag || ''}
                    onChange={e => setLocalDeviceTag(e.target.value)}
                  />
                </div>
                <div className={classes.pills}>
                  {[
                    { label: 'No portal name', val: localNoTag, set: () => setLocalNoTag(localNoTag ? 0 : 1) },
                  ].map(({ label, val, set }) => (
                    <button
                      key={label}
                      type="button"
                      className={`${classes.pill} ${val ? classes.pillActive : ''}`}
                      onClick={set}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </Section>

              {/* Users */}
              <Section label="Users" badge={usersBadge} open={openSections.users} onToggle={() => toggleSection('users')}>
                <Pills
                  options={['No users', 'Has users', 'Has > 10 users', 'Has > 20 users']}
                  selected={
                    localNoUsers === 1 ? ['No users'] :
                    localNoUsers === 2 ? ['Has users'] :
                    localNoUsers === 3 ? ['Has > 10 users'] :
                    localNoUsers === 4 ? ['Has > 20 users'] : []
                  }
                  onToggle={v => {
                    const val = v === 'No users' ? 1 : v === 'Has users' ? 2 : v === 'Has > 10 users' ? 3 : 4;
                    setLocalNoUsers(localNoUsers === val ? 0 : val);
                  }}
                />
              </Section>

              {/* Group — only when not in group sites context */}
              {!isGroupSites && (
                <Section label="Group" badge={groupBadge} open={openSections.group} onToggle={() => toggleSection('group')}>
                  <div className={classes.fieldRow}>
                    <select
                      className={classes.nativeSelect}
                      value={localGroupName || ''}
                      onChange={e => setLocalGroupName(e.target.value || null)}
                    >
                      <option value="">All groups</option>
                      {groups.map(g => g.name).sort((a, b) => a.localeCompare(b)).map(name => (
                        <option key={name} value={name}>{name}</option>
                      ))}
                    </select>
                  </div>
                  <CheckRow
                    label="Include all subgroups"
                    checked={localIncludeSubgroups === 1}
                    onChange={() => setLocalIncludesSubgroups(localIncludeSubgroups === 1 ? 0 : 1)}
                  />
                </Section>
              )}

              {/* Billing — EyeSpyFX only */}
              {isEyeSpyFX && (
                <Section label="Billing" badge={billingBadge} open={openSections.billing} onToggle={() => toggleSection('billing')}>
                  <div className={classes.subSection}>
                    <span className={classes.subLabel}>Billable</span>
                    <Pills
                      options={['Billable', 'Not billable', 'Demo']}
                      selected={localBillable === 1 ? ['Billable'] : localBillable === 0 ? ['Not billable'] : localBillable === 2 ? ['Demo'] : []}
                      onToggle={v => {
                        if (v === 'Billable') setLocalBillable(localBillable === 1 ? -1 : 1);
                        else if (v === 'Not billable') setLocalBillable(localBillable === 0 ? -1 : 0);
                        else setLocalBillable(localBillable === 2 ? -1 : 2);
                      }}
                    />
                  </div>
                  <div className={classes.subSection}>
                    <span className={classes.subLabel}>Billing frequency</span>
                    <Pills
                      options={['Monthly', 'Annually', 'Not set']}
                      selected={localBillingFrequency === 0 ? ['Monthly'] : localBillingFrequency === 1 ? ['Annually'] : localBillingFrequency === 2 ? ['Not set'] : []}
                      onToggle={v => {
                        if (v === 'Monthly') setLocalBillingFrequency(localBillingFrequency === 0 ? -1 : 0);
                        else if (v === 'Annually') setLocalBillingFrequency(localBillingFrequency === 1 ? -1 : 1);
                        else setLocalBillingFrequency(localBillingFrequency === 2 ? -1 : 2);
                      }}
                    />
                  </div>
                  <div className={classes.fieldRow}>
                    <span className={classes.fieldLabel}>Billed to</span>
                    <select
                      className={classes.nativeSelect}
                      value={localBilledTo}
                      onChange={e => setLocalBilledTo(Number(e.target.value))}
                    >
                      <option value={-1}>Any</option>
                      <option value={0}>Not set</option>
                      {[...groups].sort((a, b) => a.name.localeCompare(b.name)).map(g => (
                        <option key={g.id} value={g.id}>{g.name}</option>
                      ))}
                    </select>
                  </div>
                </Section>
              )}

            </div>
          </div>
        )}

        {/* ── Sort panel ───────────────────────────────────── */}
        {showSorts && (
          <div className={classes.panel}>
            <div className={classes.panelHeader}>
              <span className={classes.panelTitle}>Sort</span>
              <div className={classes.panelActions}>
                <button className={classes.resetBtn} type="button" onClick={HandleResetFilters}>Reset</button>
                <button className={classes.applyBtn} type="button" onClick={HandleApplyFilters}>Apply</button>
              </div>
            </div>
            <div className={classes.panelBody} style={{ padding: '14px 18px' }}>
              <div className={classes.subSection}>
                <span className={classes.subLabel}>Sort by</span>
                <div className={classes.sortGrid}>
                  {[
                    { label: 'Date created', active: localSCreated, onToggle: () => { setLocalSCreated(p => p ? 0 : 1); setLocalSUserCount(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'User count', active: localSUserCount, onToggle: () => { setLocalSUserCount(p => p ? 0 : 1); setLocalSCreated(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'Firmware', active: localSFirmware, onToggle: () => { setLocalSFirmware(p => p ? 0 : 1); setLocalSUserCount(0); setLocalSCreated(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'Site name', active: localSName, onToggle: () => { setLocalSName(p => p ? 0 : 1); setLocalSUserCount(0); setLocalSCreated(0); setLocalSFirmware(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'Camera count', active: localSCameraCount, onToggle: () => { setLocalSCameraCount(p => p ? 0 : 1); setLocalSUserCount(0); setLocalSCreated(0); setLocalSFirmware(0); setLocalSName(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'Date made active', active: localSDateMadeActive, onToggle: () => { setLocalSDateMadeActive(p => p ? 0 : 1); setLocalSCreated(0); setLocalSUserCount(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); } },
                    ...(isEyeSpyFX ? [
                      { label: 'Date of sale', active: localSDateOfSale, onToggle: () => { setLocalSDateOfSale(p => p ? 0 : 1); setLocalSCreated(0); setLocalSUserCount(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                      { label: 'Last invoice', active: localSLastInvoice, onToggle: () => { setLocalSLastInvoice(p => p ? 0 : 1); setLocalSCreated(0); setLocalSUserCount(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSDateMadeActive(0); } },
                    ] : []),
                  ].map(({ label, active, onToggle }) => (
                    <button
                      key={label}
                      type="button"
                      className={`${classes.sortPill} ${active ? classes.sortPillActive : ''}`}
                      onClick={onToggle}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
              <div className={classes.subSection} style={{ marginTop: 10 }}>
                <span className={classes.subLabel}>Direction</span>
                <div className={classes.directionRow}>
                  <button
                    type="button"
                    className={`${classes.dirPill} ${localSortAsc === 1 ? classes.dirPillActive : ''}`}
                    onClick={() => setLocalSortAsc(1)}
                  >↑ Ascending</button>
                  <button
                    type="button"
                    className={`${classes.dirPill} ${localSortAsc === 0 ? classes.dirPillActive : ''}`}
                    onClick={() => setLocalSortAsc(0)}
                  >↓ Descending</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {activeChips.length > 0 && (
        <div className={classes.activeFilters}>
          {activeChips.map(({ key, label }) => (
            <span key={key} className={classes.filterChip}>
              {label}
              <button className={classes.filterChipClear} onClick={() => clearFilter(key)} type="button">×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default AllSitesSearchBar;
